import type { Timestamp } from 'firebase/firestore'

export type CompanyUserInput = Omit<CompanyUser, 'id' | 'createdAt'>

export enum CompanyUserRole {
  SUPER_ADMIN = 'superAdmin',
  ADMIN = 'admin',
  PR_MANAGER = 'prManager',
  PR_MEMBER = 'prMember',
  MEDIA_MEMBER = 'mediaMember',
}

export interface CompanyUser {
  id?: string
  role?: CompanyUserRole
  userID?: string
  companyID?: string
  createdAt?: Timestamp
  inviteID?: string
  invitedAt?: Timestamp // Date when user accepted the invite (original invite creation date)
}
